export const DELIVERY_FEATURE_LAZY = 'deliveryFeatureLazy';
export const DELIVERY_UI_DELIVERY_CALCULATOR_FORM_LAZY = 'deliveryUiDeliveryCalculatorFormLazy';
export const DELIVERY_UI_DELIVERY_MAP_LAZY = 'deliveryUiDeliveryMapLazy';
